export default __webpack_public_path__ + "static/media/thank-you-back.d3779657.png";